module.exports = __webpack_public_path__ + "media/directory/forum_icon_hover-6323551f.svg";